export default __webpack_public_path__ + "static/media/35.5b57054b.mp3";